<template>
    <div v-if="namespace && userMedia.length > 0">
        <ul class="MediaSelector__selector">
            <li v-for="item in userMedia" :key="'media-' + namespace + '-user-' + item.id" class="Media">
                <input :id="'media-' + namespace + '-user-' + item.id"
                       :name="'media-' + namespace + '-user[]'"
                       class="Media__input"
                       type="radio"
                       :value="item.id"
                       v-model="selectedImage"
                       @change="selectMedia(item)"
                >
                <label :for="'media-' + namespace + '-user-' + item.id"
                       class="Media__label"
                >
                    <span class="image-wrap">
                        <span class="image-inner">
                            <img v-if="item.extension === 'pdf'" :src="storage + 'placeholder/pdf-placeholder.jpg'" alt=""/>
                            <!-- Add selected image ID as query var to force reload -->
                            <img v-else :src="storage + item.directory + '/' + item.filename + '.' + item.extension + '?' + selectedImage"
                                 alt=""
                            />
                        </span>
                    </span>

                    <span class="image-filename">
                        <span>
                            {{item.filename}}.{{item.extension}}
                        </span>
                    </span>

                    <span class="delete">
                        <v-btn icon @click="openDeleteDialog(item.id)">
                            <v-icon small color="#bcbcbc">fas fa-trash</v-icon>
                        </v-btn>
                    </span>
                </label>
                <button class="selected" @click.stop="deselectMedia">
                    <v-icon color="white">fas fa-check-circle</v-icon>
                    <span style="width: 100%; flex: 0 0 100%; margin-top: 8px; ">
                        Click to deselect
                    </span>
                </button>
            </li>
        </ul>
        <v-dialog v-model="showImageDeleteDialog" max-width="320px">
            <v-card>
                <v-card-title>Delete File?</v-card-title>
                <v-card-text>
                    <p>Deleting this file will remove it from all other fields where it may be attached. If you're sure you don't need this file, click Delete to continue.</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeDeleteDialog">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" @click="deleteMedia">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="MediaSelector__no-images" v-else>
        <p>You haven't uploaded any <span v-if="uploadType === 'image'">images</span><span v-else>files</span> yet.</p>
        <v-btn color="primary" @click="setUploadTab">
            <v-icon left small>fas fa-cloud-upload-alt</v-icon>
            <span>Click here to upload</span>
        </v-btn>
    </div>
</template>

<script>
import store from '@/store/store';

export default {
    props: {
        namespace: {
            type: String,
            required: true
        },

        uploadType: {
            type: String,
            required: true
        },

        preloadedUserMedia: {
            type: Array,
        }
    },

    computed: {
        userMedia: {
            get: function() {
                return store.state[this.namespace].userMedia;
            },
            set: function(value) {
                store.commit(`${this.namespace}/setUserMedia`, value);
            }
        },

        selectedImage: {
            get: function() {
                return store.state[this.namespace].selectedImage;
            },
            set: function(value) {
                store.commit(`${this.namespace}/setSelectedImage`, value);
            }
        },

        selectedImageSrc: {
            get: function() {
                return store.state[this.namespace].selectedImageSrc;
            },
            set: function(value) {
                store.commit(`${this.namespace}/setSelectedImageSrc`, value);
            }
        },

        showImageDeleteDialog: {
            get: function() {
                return store.state[this.namespace].showImageDeleteDialog;
            },

            set: function(value) {
                store.commit(`${this.namespace}/toggleImageDeleteDialog`, value);
            }
        }
    },

    data() {
        return {
            imageToDelete: undefined,
            storage: this.$storageURL,
        };
    },

    mounted() {
        if(this.preloadedUserMedia) {
            store.dispatch(`${this.namespace}/preloadUserMedia`, this.preloadedUserMedia)
                .then(() => {
                    this.setSelected();
                })
                .catch(() => {
                    store.commit(`${this.namespace}/toggleOverlay`, false);
                });
        }
    },

    methods: {
        deselectMedia() {
            store.dispatch(`${this.namespace}/onThumbnailDeselect`, {item: '', namespace: this.namespace});
        },

        selectMedia(item){
            store.dispatch(`${this.namespace}/onThumbnailSelect`, {item: item, namespace: this.namespace});
        },

        setUploadTab() {
            store.commit(`${this.namespace}/setActiveTab`, 'upload');
        },

        openDeleteDialog(itemId) {
            this.imageToDelete = itemId;
            store.commit(`${this.namespace}/toggleImageDeleteDialog`, true);
        },

        closeDeleteDialog() {
            this.imageToDelete = undefined;
            store.commit(`${this.namespace}/toggleImageDeleteDialog`, false);
        },

        deleteMedia() {
            store.commit(`${this.namespace}/toggleOverlay`, true);
            store.dispatch(`${this.namespace}/deleteUserMedia`, this.imageToDelete);
            store.dispatch(`${this.namespace}/setDefaultSelectedImage`);
            store.commit(`${this.namespace}/toggleOverlay`, false);
            this.closeDeleteDialog();
        },

        filterMedia() {
            return new Promise((resolve, reject) => {
                let media = [];
                if(this.userMedia) {
                    if (this.uploadType === 'image') {
                        this.userMedia.forEach(file => {
                            if (file.aggregate_type !== 'pdf') {
                                media.push(file);
                            }
                        });
                    }

                    if(this.uploadType === 'pdf') {
                        this.userMedia.forEach(file => {
                            if (file.aggregate_type === 'pdf') {
                                media.push(file);
                            }
                        });
                    }
                    this.userMedia = media;
                    resolve();
                }
                reject();
            });
        },

        setSelected() {
            store.dispatch(`${this.namespace}/setSelectedImage`, this.selectedImage)
                .then(() => {
                    store.dispatch(`${this.namespace}/getSelectedImage`)
                        .then(() => {
                            store.commit(`${this.namespace}/toggleOverlay`, false);
                        })
                        .catch(() => {
                            // Fall Back to the first image in the library.
                            store.dispatch(`${this.namespace}/setDefaultSelectedImage`);
                            store.commit(`${this.namespace}/toggleOverlay`, false);
                        });
                })
                .catch(() => {
                    store.commit(`${this.namespace}/toggleOverlay`, false);
                });
        }
    }
};
</script>
